import Model from './Model'
export default class Equipment extends Model {

    resource()
    {
        return 'equipments'
    }
}
